/* vendorForecastTypes.js -- THE vendor forecast vocabularies: the forecast types and the per-seat bases a vendor's
 * forecast can take. ONE owner (2026-10-29, the vendor-forecast file): the Forecast Wizard's Type and seat-basis
 * selects and the vendor-forecast template (templateSpecs.js) read these very arrays -- they used to be page-local
 * constants inside pages/ForecastWizard.jsx (VENDOR_TYPES, SEAT_BASIS_OPTIONS), moved here unchanged.
 *
 * `id` is the stored value (vendors.forecast_type / vendors.seat_basis); `label` is what the screen and the template
 * show. prepaid and skip are NOT here: a prepaid vendor is forecast from its contracts (the Prepaid sub-step), and
 * skip is a Step-6 parse choice, not a forecast.
 *
 * Plain ASCII only (the generated template document inherits these labels). */

export const VENDOR_TYPES = [
  { id: 'constant', label: 'Fixed Monthly' },
  { id: 'pct_revenue', label: '% of Revenue' },
  { id: 'per_seat', label: 'Per Seat' },
  { id: 'one_off', label: 'One-Off / Manual' },
];

export const SEAT_BASIS_OPTIONS = [
  { id: 'fte', label: 'FTE Only' },
  { id: 'contractors', label: 'Contractors Only' },
  { id: 'both', label: 'FTE + Contractors' },
];

/* Other spellings a file may use for a value (compared trimmed and case-insensitively, like the labels). Every id is
 * accepted too, so a converter may write either the label or the stored value. */
export const VENDOR_TYPE_VALUE_ALIASES = ['constant', 'pct_revenue', 'per_seat', 'one_off', 'Fixed', 'One-Off', 'One Off', 'Percent of Revenue'];
export const SEAT_BASIS_VALUE_ALIASES = ['fte', 'contractors', 'both', 'FTE', 'Contractors', 'Both'];

const ALIAS_TO_ID = {
  fixed: 'constant', 'one-off': 'one_off', 'one off': 'one_off', 'percent of revenue': 'pct_revenue',
};
const BASIS_ALIAS_TO_ID = { fte: 'fte', contractors: 'contractors', both: 'both' };

const key = (v) => String(v == null ? '' : v).trim().toLowerCase();

/* A cell -> the stored id, or null (blank or not recognised). One reader for the template parser and the gate. */
export function normalizeVendorType(v) {
  const k = key(v);
  if (!k) return null;
  const hit = VENDOR_TYPES.find(t => t.id === k || t.label.toLowerCase() === k);
  return hit ? hit.id : (ALIAS_TO_ID[k] || null);
}
export function normalizeSeatBasis(v) {
  const k = key(v);
  if (!k) return null;
  const hit = SEAT_BASIS_OPTIONS.find(t => t.id === k || t.label.toLowerCase() === k);
  return hit ? hit.id : (BASIS_ALIAS_TO_ID[k] || null);
}
export const vendorTypeLabel = (id) => (VENDOR_TYPES.find(t => t.id === id) || {}).label || id;
export const seatBasisLabel = (id) => (SEAT_BASIS_OPTIONS.find(t => t.id === id) || {}).label || id;
